import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const Aside = ()=>{

  const location = useLocation();
  const { hasRole } = useAuth();
    return (
      <aside>
        <label
          class="fas fa-close cursor-pointer aside-close"
          htmlFor="aside-toggle-checkbox"
        />
        <span className="aside-title">Dashboard</span>
        <div className="sidebar">
          <ul className="nav-sidebar">
            <li className="nav-item active d-none">
              <NavLink to="/dashboard" className="nav-link">
                <i className="nav-icon fas fa-tachometer-alt"></i>
                <p>Dashboard</p>
              </NavLink>
            </li>

            <li
              className={`nav-item ${location.pathname === "/equipment-certificates" ? "active" : ""}`}
            >
              <NavLink to="/equipment-certificates" className="nav-link">
                <i className="nav-icon fas fa-certificate"></i>
                <p>Equipment Certificates</p>
              </NavLink>
            </li>
            <li
              className={`nav-item ${location.pathname === "/id-cards" ? "active" : ""}`}
            >
              <NavLink to="/id-cards" className="nav-link">
                <i className="nav-icon fas fa-id-card"></i>
                <p>Id Cards</p>
              </NavLink>
            </li>
            {hasRole("Admin") && (
              <li
                className={`nav-item ${location.pathname === "/users" ? "active" : ""}`}
              >
                <NavLink to="/users" className="nav-link">
                  <i className="nav-icon fas fa-users"></i>
                  <p>Users</p>
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </aside>
    );
}

export default Aside;